<template>
  <div class="row">
    <div class="col-sm-6 content-wrapper">
      <template v-if="candidate.type === 0">
        <label class="col-sm-12 mb-sm-1">{{ candidate.title }} | Employment</label>
        <label class="col-sm-12 mb-sm-1">{{ candidate.company_name }}</label>
        <label class="col-sm-12 mb-sm-1">{{ candidate.start_date_formatted || (candidate.start_date ? dateFormatter(candidate.start_date) : '') }} -
          {{ candidate.end_date_formatted || formatEndDate(candidate) }} | {{ candidate.company_address }}</label>
        <label class="col-sm-12 mb-sm-1">{{ calculateDifference(candidate.end_date, candidate.start_date) }}</label>
      </template>
      <template v-if="candidate.type === 1">
        <label class="col-sm-12 mb-sm-1">{{ candidate.qualification }} | Education</label>
        <label class="col-sm-12 mb-sm-1">{{ candidate.institute }}</label>
        <label class="col-sm-12 mb-sm-1">{{ candidate.start_date_formatted || (candidate.start_date ? dateFormatter(candidate.start_date) : '') }} -
          {{ candidate.end_date_formatted || formatEndDate(candidate) }} | {{ candidate.institute_address }}</label>
        <label class="col-sm-12 mb-sm-1">{{ calculateDifference(candidate.end_date, candidate.start_date) }}</label>
      </template>
      <template v-if="candidate.type === 2">
        <label class="col-sm-12 mb-sm-1">{{ candidate.name }} | Self-Employment / Trade</label>
        <label class="col-sm-12 mb-sm-1">{{ candidate.utr_number }}</label>
        <label class="col-sm-12 mb-sm-1">{{ candidate.start_date_formatted || (candidate.start_date ? dateFormatter(candidate.start_date) : '') }} -
          {{ candidate.end_date_formatted || formatEndDate(candidate) }} | {{ candidate.address }}</label>
        <label class="col-sm-12 mb-sm-1">{{ calculateDifference(candidate.end_date, candidate.start_date) }}</label>
      </template>
      <template v-if="candidate.type === 3">
        <label class="col-sm-12 mb-sm-1">Unemployed</label>
        <label class="col-sm-12 mb-sm-1">
          {{ candidate.start_date_formatted || (candidate.start_date ? dateFormatter(candidate.start_date) : '') }} - {{ candidate.end_date_formatted || formatEndDate(candidate) }}
        </label>
        <label class="col-sm-12 mb-sm-1">{{ calculateDifference(candidate.end_date, candidate.start_date) }}</label>
      </template>
      <customized-comments
          :comment="comment"
          :history="candidate"
          :applicant="applicant"
          :company="company"
          :applicantId="applicantId"
          :statusable_type="statusable_type"
          :statusable_id="statusable_id"
          :emailAddress="emailAddress"
          :steps="steps"
          @status-updated="$emit('status-updated', $event)"
      />
    </div>
    <div class="col-sm-6 content-wrapper">
      <h6>
        Action History:
      </h6>

      <div class="form-group">
        <comments-steps-tree :steps="steps"
                             :history="candidate"
                             :emailAddress="emailAddress"
                             @node-delete="deleteNode"
                             @node-edit="editNode"
                             @comment-updated="handleCommentUpdate"
        />
        <comments-list v-if="showCommentList"
                       :comment="commentToEdit"
                       :applicantId="applicantId"
                       :emailAddress="emailAddress"
                       @close-comment-listing="closeComment"
                       :steps="steps"
        />

      </div>
    </div>
  </div>
</template>

<script>
import {Comment} from "@Views/Screening/utility/apiAgent";

import {
  calculateDifference,
  dateFormatter
} from "@Views/Screening/utility/common";
import {_status, oralSteps, writtenSteps} from "@Views/Screening/utility/constant";
import {updateCommentSteps, } from "@Views/Screening/utility/common/comment";

export default {
  name: "HistoryComments",
  props: {
    candidate: {
      type: Object
    },
    applicant: {
      type: Object,
      default: () => ({})
    },
    company: {
      type: Object,
      default: () => ({})
    },
    applicantId: {
      type: Number
    },
    statusable_type: {
      type: String
    },
    statusable_id: {
      type: Number
    },
    emailAddress: {
      type: String
    },
    comment: {
      type: Array
    }
  },
  data() {
    return {
      steps: [],
      showCommentList: false,
      commentToEdit: {},
      statusList: _status,
      oralSteps: oralSteps,
      writtenSteps: writtenSteps,
      isShowStatus: false
    }
  },
  created() {
    this.setStepsOnInitialization();
  },
  watch: {
    comment: {
      handler() {
        this.setStepsOnInitialization();
      },
      deep: true
    },
    statusable_id() {
      this.setStepsOnInitialization();
    }
  },

  methods: {
    dateFormatter,
    updateCommentSteps,
    calculateDifference,
    formatEndDate(item) {
      if (!item) return 'N/A';
      if (item.current_status) return 'Till Present';
      return item.end_date ? this.dateFormatter(item.end_date) : 'N/A';
    },
    handleCommentUpdate(updatedChild) {
      // Update the local steps array with the updated comment data
      this.steps.forEach(step => {
        const childIndex = step.children?.findIndex(child => child.id === updatedChild.id);
        if (childIndex !== -1 && childIndex !== undefined) {
          // Update the specific child with fresh data
          this.$set(step.children, childIndex, {
            ...step.children[childIndex],
            action_comment: updatedChild.action_comment,
            created_at: updatedChild.created_at,
            include_in_report: !!updatedChild.include_in_report,
            applicant_files: updatedChild.applicant_files || []
          });
        }
      });
      
      // Emit to parent component with correct payload structure
      this.$emit('status-updated', {
        id: updatedChild.id,
        statusable_id: updatedChild.statusable_id || this.candidate.id,
        statusable_type: updatedChild.statusable_type || this.candidate.statusable_type,
        action_comment: updatedChild.action_comment,
        created_at: updatedChild.created_at,
        include_in_report: !!updatedChild.include_in_report,
        applicant_files: updatedChild.applicant_files || [],
        screening_endorsement: updatedChild.screening_endorsement
      });
    },
    editNode(updatedCommentObj) {
      this.commentToEdit = { ...updatedCommentObj };
      this.showCommentList = true;
    },
    closeComment(event) {
      this.commentToEdit = {};
      this.showCommentList = !!event; // false to close
    },
    deleteNode(commentObj) {
      if (!window.confirm("Are you sure you want to delete this action?")) {
        return;
      }

      const commentId = commentObj.id;

      Comment.deleteComment(commentId)
          .then(() => {
            let indexToRemove = this.steps.findIndex(step =>
                step.children?.some(child => child.id === commentId)
            );
            if (indexToRemove !== -1) {
              this.steps[indexToRemove].children = this.steps[indexToRemove].children.filter(child => child.id !== commentId);
              if (this.steps[indexToRemove].children.length === 0) {
                this.steps.splice(indexToRemove, 1);
              }
            }
            this.$emit('status-deleted', {
              id: commentId,
              type: this.statusable_type,
              statusable_id: this.statusable_id,
              screening_endorsement: commentObj.screening_endorsement || null
            });
            this.$toastr.s("Comment deleted successfully!");
          })
          .catch(error => {
            this.$toastr.e("Failed to delete comment.");
            console.error(error);
          });
    },

    setStepsOnInitialization() {
      this.steps.splice(0);
      const comments = Array.isArray(this.comment) ? this.comment : [];
      for (const _comment of comments) {
        const o = {
          id : _comment.id,
          _expanded : false,
          _editing : false,
          created_at: _comment.created_at,
          action_comment: _comment.action_comment,
          include_in_report: !!_comment.include_in_report,
          auto_reminder_enabled: _comment.auto_reminder_enabled,
          status: _comment.status,
          applicant_files: _comment.applicant_files,
          statusable_id : _comment.statusable_id,
          statusable_type : _comment.statusable_type,
          screening_endorsement : _comment.screening_endorsement ?? {},
        };
        this.updateCommentSteps(o, true);
      }
    },
    setIsShowStatus() {
      this.isShowStatus = !this.isShowStatus;
    }
  }
}
</script>

<style scoped></style>
